import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldTextarea } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const ArrayFieldToBlock: FieldToBlock<
  'array',
  WorkflowStepFormFieldTextarea
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'textarea',
  componentProps: {
    size: 'sm',
  },
});

type ArrayFieldValueProps = FieldValueProps<'array'>;

export const ArrayFieldValue: FC<ArrayFieldValueProps> = ({ field }) => (
  <Text whiteSpace="pre">{field.value}</Text>
);
